export enum FeedScreenNames {
  FEED = 'feed',
  GALLERY = 'gallery',
  MAIN = 'feed-nav',
}
